// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SiteSwitcher_Wrapper__KxwkJ","Title":"SiteSwitcher_Title___js5x","Arrow":"SiteSwitcher_Arrow__cZyC6"};